<template>
  <div>
    <!--        <section  v-show="!lastStep" class="quiz">-->
    <!--            <div class="quiz__ring&#45;&#45;mobile"><img src="img/quiz/ringMobile.png" alt="ring"></div>-->
    <!--            <div class="quiz__circle&#45;&#45;mobile"><img src="img/quiz/circleMobile.png" alt="circle"></div>-->
    <!--            <div class="quiz__ring"><img src="img/quiz/ring.png" alt="ring"></div>-->
    <!--            <div class="quiz__circle"><img src="img/quiz/circle.png" alt="circle"></div>-->

    <!--            <div class="container quiz__container step">-->
    <!--                <div class="quiz__box quiz__box&#45;&#45;img"><img src="img/quiz/money.png" alt="money"></div>-->
    <!--                &lt;!&ndash; /.quiz__box &ndash;&gt;-->
    <!--                <a class="close" href="/"></a>-->
    <!--                <div class="quiz__box">-->
    <!--                    <form class="quiz__form" action="#" @submit.prevent="">-->
    <!--                            <div class="quiz__box-wrap">-->
    <!--                                <transition appear enter-active-class="animate__animated animate__fadeIn" leave-active-class="animate__animated animate__fadeOut">-->
    <!--                                    <h6 v-show="myShow" class="quiz__box-title">{{ questions[step].question }}</h6>-->
    <!--                                </transition>-->
    <!--                                <label-->
    <!--                                    v-for="(answer,index) in questions[step].answers"-->
    <!--                                    :key="index"-->
    <!--                                    class="quiz__label"-->
    <!--                                >-->
    <!--                                    <input-->
    <!--                                        class='quiz__input'-->
    <!--                                        type="radio"-->
    <!--                                        name="type"-->
    <!--                                        v-model="dataAnswer"-->
    <!--                                        @change="setAnswer"-->
    <!--                                        :value="answer"-->
    <!--                                    >-->
    <!--                                    <transition appear enter-active-class="animate__animated animate__fadeIn" leave-active-class="animate__animated animate__fadeOut" >-->
    <!--                                        <p v-show="myShow" class="quiz__input-text"> {{ answer  }} </p>-->
    <!--                                    </transition>-->
    <!--                                </label>-->
    <!--                            </div>-->
    <!--                        <div class="step__button-wrap">-->
    <!--                            <button v-if="step > 0" class="step__button step__button&#45;&#45;back" @click="prevNext(-1)">Назад</button>-->
    <!--                            <button v-if="step !== questions.length " class="step__button" @click="prevNext(1)">Далее</button>-->
    <!--                        </div>-->
    <!--                    </form>-->
    <!--                </div>-->
    <!--                &lt;!&ndash; /.quiz__box &ndash;&gt;-->
    <!--            </div>-->
    <!--        </section>-->
    <section v-if="!lastStep" class="section quiz">
      <div class="container-medium">
        <h3 class="section__title quiz__title quiz__text--mobile">
          Вы можете пройти процедуру банкротства
        </h3>
        <p class="section__subtitle quiz__subtitle quiz__text--mobile">
          с любой суммой задолженности.
        </p>
        <p class="subtitle-purple quiz__text--mobile">
          Когда сумма задолженности <strong>от 200 000 рублей,</strong> то
          процедура банкротства становится экономически выгодной.
        </p>

        <div class="row quiz__row quiz__row--mobile">
          <div class="quiz__img quiz__img--mobile">
            <img src="img/quiz/dollars.png" alt="dollars" />
            <div class="quiz__dots">
              <img src="img/quiz/dots.png" alt="dots" />
            </div>
          </div>

          <div class="quiz__box quiz__box--mobile">
            <transition
              appear
              enter-active-class="animate__animated animate__fadeIn"
              leave-active-class="animate__animated animate__fadeOut"
            >
              <p
                v-show="myShow"
                class="quiz__box-title quiz__box-title--mobile"
              >
                {{ questions[step].question }}
              </p>
            </transition>

            <form action="#" class="quiz__form" @submit.prevent="">
              <div class="quiz__form-box">
                <div
                  v-for="(answer, index) in questions[step].answers"
                  :key="index"
                  class="quiz__input-group"
                >
                  <transition
                    appear
                    enter-active-class="animate__animated animate__fadeIn"
                    leave-active-class="animate__animated animate__fadeOut"
                  >
                    <label v-show="myShow" class="quiz__label">
                      <input
                        class="quiz__input"
                        type="radio"
                        v-model="dataAnswer"
                        @change="setAnswer"
                        :value="answer"
                      />
                      <div class="quiz__marker">
                        <div class="quiz__dot"></div>
                      </div>
                      <transition
                        appear
                        enter-active-class="animate__animated animate__fadeIn"
                        leave-active-class="animate__animated animate__fadeOut"
                      >
                        <span v-show="myShow" class="quiz__span">{{
                          answer
                        }}</span>
                      </transition>
                    </label>
                  </transition>
                </div>
              </div>

              <div class="quiz__button-group">
                <button
                  v-if="step > 0"
                  class="button quiz__button button--gray"
                  @click="prevNext(-1)"
                >
                  Назад
                </button>
                <button
                  v-if="step !== questions.length"
                  class="button quiz__button"
                  @click="prevNext(1)"
                >
                  Далее
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <last-step v-if="lastStep"></last-step>
  </div>
</template>

<script>
export default {
  name: "Quiz",
  data: () => ({
    dataAnswer: "",
    myShow: true,
  }),
  computed: {
    questions() {
      return this.$store.getters.getQuestions;
    },
    step() {
      return this.$store.getters.getStep;
    },
    lastStep() {
      return this.$store.getters.getLastStep;
    },
    getDataAnswer() {
      if (this.$store.getters.getDataAnswer[this.step])
        return this.$store.getters.getDataAnswer[this.step].answer;
      return false;
    },
  },
  methods: {
    prevNext(val) {
      //$('input[type="radio"]').removeAttr('checked')
      this.$store.dispatch("prevNext", val);
      this.dataAnswer = "";
      if (this.getDataAnswer) this.dataAnswer = this.getDataAnswer;
    },
    setAnswer() {
      const object = {
        question: this.questions[this.step].question,
        answer: this.dataAnswer,
      };

      this.$store.dispatch("setData", object);
      this.myShow = false;
      setTimeout(() => {
        this.myShow = true;
        this.prevNext(1);
      }, 500);
    },
  },
};
</script>

<style scoped>
.close {
  position: absolute;
  right: 32px;
  top: 32px;
  width: 32px;
  height: 32px;
  opacity: 0.3;
}
.close:hover {
  opacity: 1;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: " ";
  height: 33px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
</style>
